// Corte da redação — exibição compartilhada (admin / analista)

export const fmtExamNota = (v) => {
  if (v == null || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
};

const appPaymentOkForEssay = (app) => {
  const ex = app.exemption_status || '';
  if (ex === 'approved' || ex === 'appeal_approved') return true;
  return (app.payment_status || '') === 'paid';
};

/** @returns {{ label: string, detail: string, color: string }} */
export const essayCutDisplay = (app) => {
  if (!appPaymentOkForEssay(app)) {
    return { label: 'Não', detail: 'pagamento', color: '#9CA3AF' };
  }
  if (app.exam_objective_disqualified_zero) {
    return { label: 'Não', detail: 'zero em área', color: '#B91C1C' };
  }
  if (app.exam_final_score == null) {
    return { label: 'Não', detail: 'sem nota obj.', color: '#9CA3AF' };
  }
  if (app.essay_correction_eligible) {
    const rank = app.essay_for_correction_rank;
    return { label: 'Sim', detail: rank != null ? `#${rank}` : '—', color: '#166534' };
  }
  return { label: 'Não', detail: 'fora do corte', color: '#6B7280' };
};
